import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Field } from 'redux-form';

import { Typography } from '@material-ui/core';
import FormHelperText from '@material-ui/core/FormHelperText';

import { Input } from 'components';
import useStyles from 'pages/book-activity/components/number-of-participants/styles';

import { currencyFormatter } from 'utils/prices/formatter';

const Errors = ({ submitFailed, error, errorClassName }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  if (!submitFailed || !error) return null;

  const exceedError = error.indexOf('The number of') === 0;

  if (exceedError) {
    const errorSplit = error.split(' ');
    const errorLength = errorSplit.length;
    const staticError = errorSplit.slice(0, -1).join(' ');
    return (
      <FormHelperText
        className={classNames(classes.errorUnit, errorClassName)}
        error
      >
        {t(staticError, { number: errorSplit[errorLength - 1] })}
      </FormHelperText>
    );
  }

  return (
    <FormHelperText className={classNames(classes.errorUnit, errorClassName)} error>
      {t(error)}
    </FormHelperText>
  );
};

const UnitsInputField = ({
  fields,
  title,
  className,
  errorClassName,
  currency,
  meta: { submitFailed, error }
}) => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div>
      {title && (
        <Typography variant="h2" className={classes.inputIndent}>
          {t(title)}
        </Typography>
      )}
      <div className={classNames(classes.units, className)}>
        {fields.map((field, index) => {
          const item = fields.get(index);
          const itemCurrency = currency || item.currency;
          const formattedCurrencyValue = currencyFormatter(item[itemCurrency]);

          let label = ``;
          if (item.title && item.title.length) label = `${t(item.title)} • `;
          label += `${itemCurrency} ${formattedCurrencyValue}`;

          return (
            <div key={item.id} className={classes.unit}>
              <Field
                name={`${field}.availableUnits`}
                isOnlyNumber={true}
                maxLength={9}
                isHiddenErrorMsg={true}
                className={classes.inputField}
                label={label}
                component={Input}
              />
            </div>
          );
        })}
      </div>

      <Errors
        error={error}
        submitFailed={submitFailed}
        errorClassName={errorClassName}
      />
    </div>
  );
};

export default UnitsInputField;